import styled from "styled-components";

export const SBreadcrumbRight = styled.span`
    margin-left: auto;
`;
